import PropTypes from 'prop-types';
import './Skeleton.css';
 
const Skeleton = ({ width = '100%', height = '1rem' }) => {
  return (
    <div
      className='skeleton-line'
      style={{
        width,
        height,
      }}
    />
  );
};
 
Skeleton.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
 
export default Skeleton;